export function minAbs(value: number, limit: number) {
  if (Math.abs(value) > limit) {
    return Math.sign(value) * limit;
  }
  return value;
}

export function maxAbs(value: number, limit: number) {
  if (Math.abs(value) < limit) {
    return Math.sign(value) * limit;
  }
  return value;
}

export function interpColour(colour1: number, colour2: number, strength: number) {

  const r1 = (colour1 >> 16) & 0xff;
  const g1 = (colour1 >> 8) & 0xff;
  const b1 = colour1 & 0xff;

  const r2 = (colour2 >> 16) & 0xff;
  const g2 = (colour2 >> 8) & 0xff;
  const b2 = colour2 & 0xff;

  const r = Math.round(r1 + (r2-r1)*strength) & 0xff;
  const g = Math.round(g1 + (g2-g1)*strength) & 0xff;
  const b = Math.round(b1 + (b2-b1)*strength) & 0xff;


  return (r << 16) | (g << 8) | b

}
